import * as BBApi from '../..'

const rootUrl = BBApi.host + '/oplevalt/cms/pages/'

export type Page = {
	id: string
	_id: string
	title: string
	url: string
	category: string
	metaDescription: string
	sections: string[]
	created: string
	updated: string
}

export type PageCreate = { id: number } & Omit<Page, '_id' | 'sections' | 'created' | 'updated'>

export const query = async (values: any = null) => {
	const url = new URL(rootUrl)
	if (values?.search) url.searchParams.append('search', values.search)

	const response = await BBApi.get(url.href)
	const pages = await response.json()
	return pages as Page[]
}

export const get = async (id: string) => {
	const response = await BBApi.get(rootUrl + id)
	const page = await response.json()
	return page as Page
}

export const create = async (pageCreate: PageCreate) => {
	try {
		const response = await BBApi.post(rootUrl, pageCreate)
		const pageId = await response.text()
		return pageId
	} catch (error) {
		if (error instanceof Error && error.message === 'url already exists') {
			throw new Error(error.message)
		}

		throw error
	}
}

export const remove = async (pageId: string) => {
	await BBApi.del(rootUrl + pageId)
}

export const update = async (pageId: string, pageUpdate: any) => {
	try {
		const response = await BBApi.patch(rootUrl + pageId, pageUpdate)
		const page = await response.json()
		return page
	} catch (error) {
		if (error instanceof Error && error.message === 'url already exists') {
			throw new Error(error.message)
		}

		throw error
	}
}
